/**
 * Archivo: AutorizacionServicios.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este fichero contiene las funciones para la autenticación de los usuarios y el registro de los mismos en la aplicación.
 * Incluye funciones para iniciar sesión, registrar nuevos usuarios y cerrar sesión, utilizando cookies para la gestión de tokens.
 * 
 * Dependencias:
 * - js-cookie: ^3.0.1
 * - crypto-js: ^4.0.0
 * 
 * Propósito:
 * Proveer funciones para la gestión de la autenticación de los usuarios, incluyendo la encriptación de contraseñas 
 * antes de enviarlas al servidor.
 */
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

// Voy a usar una clase secreta que conoce tanto el back como el front, para cifrar las contraseñas y enviarlas al back
const secretKey = process.env.REACT_APP_SECRET_KEY_PASSWORD; 
const API = process.env.REACT_APP_API_BASE_URL; 

function encriptarContraseña(c) {
    return CryptoJS.AES.encrypt(c, secretKey).toString();
}

//Función para añadir un usuario a la lista de usuarios permitidos
export const iniciarSesion = async (correo, contraseña) => {
    const urlIniciarSesion = `${API}/api/iniciarSesion`;
    //console.log("Acción de iniciar sesion, correo: ", correo, 'contraseña ', contraseña)
    let errores = [];
    if (correo === '' || contraseña === '') {
        errores.push('Alguno de los campos está vacío')
    } else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo)) {
        errores.push('El formato de correo es incorrecto.')
    }
    if (errores.length > 0) {
        return { success: false, message:errores.join(' ')};
    } else {
        try {
            //Cifro la contraseña
            const contraseñaCifrada = encriptarContraseña(contraseña)
            console.log("Contraseña cifrada: ", contraseñaCifrada)
            console.log("URL: ", urlIniciarSesion)
            const response = await fetch(urlIniciarSesion, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    correo, 
                    contraseña: contraseñaCifrada 
                }),
            });
            console.log("Response: ", response)
            const data = await response.json();
            console.log("Data: ", data.message)
            console.log("Respuesta de la API: ", data);
            if (data.message === 'OK') {
                Cookies.set('token', data.body[0].token);
                Cookies.set('permisos', data.body[0].permisos);
                return { success: true, data: data.message };
            } else {
                console.log('Error al iniciar sesión: ' + data.error);
                return { success: false, message: data.error };
            }
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return { success: false, message: 'Error al enviar la solicitud' };
        }
    }
};

export const logout = () => {
    Cookies.remove('token');
    Cookies.remove('permisos');
};

//Función para registrar un usuario a la aplicación 
export const registrarse = async (correo, contraseña, confContraseña) => {
    const urlRegistroSesion = `${API}/api/registroSesion`;
    let errores = [];
    if (correo === '' || contraseña === '' || confContraseña === '') {
        errores.push('Alguno de los campos está vacío')
    } else if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo)) {
        errores.push('El formato de correo es incorrecto.')
    } else if (contraseña.length < 8) {
        errores.push('La contraseña tiene que tener 8 carácteres o más');
    } else if (contraseña !== confContraseña) {
        errores.push('Las contraseñas introducidas son diferentes');
    }
    if (errores.length > 0) {
        return { success: false, message:errores.join(' ')};
    } else { 
        //console.log("Ningún error, voy a registrar al usuario")
        //Encripto las contraseñas antes de mandarlas al back
        const contraseñaCifrada = encriptarContraseña(contraseña)
        const confContraseñaCifrada = encriptarContraseña(confContraseña)
        //console.log("Contraseña cifrada: ", contraseñaCifrada)
        try {
            const response = await fetch(urlRegistroSesion, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ 
                    correo: correo, 
                    contraseña: contraseñaCifrada, 
                    confContraseña: confContraseñaCifrada
                }),
            });
            const data = await response.json();
            //console.log("Respuesta de la API: ", data);
            if (data.message === 'OK') {
                return { success: true, data: data.message };
            } else {
                console.log('Error al registrar usuario: ' + data.error);
                return { success: false, message: data.error };
            }
        } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            return { success: false, message: 'Error al enviar la solicitud' };
        }
    }
};